export default __webpack_public_path__ + "static/bara_studio_black-0f8298b2ef3aac1913b3f692c645d672.png";